import React from "react";
import { Portfolio } from '../components/Portfolio';

const PortfolioPage = () => (
  <div className="pt-8">
    <Portfolio />
  </div>
);

export default PortfolioPage;